
import { language, localLanguage } from '@/common/storage';
import { isMobileDevice } from '@com/utils/browser-detection/index';

export default {
  props: ['isEdittingTopbar'],
  components: {},
  data: function data() {
    return {
      languageList: [{
        value: 'zh-cn',
        label: '中文'
      }, {
        value: 'en',
        label: 'English'
      }, {
        value: 'ja',
        label: '日本語'
      }],
      visible: false
    };
  },

  methods: {
    handleDropdownTouch: function handleDropdownTouch(command) {
      // 兼容移动端无点击事件导致el-dropdown无法触发问题
      this.handleLanguageChange(command);
    },
    refresh: function refresh() {
      if (isMobileDevice()) {
        window.location.reload();
      } else {
        this.$router.go(0);
      }
    },
    handleLanguageChange: function handleLanguageChange(command) {
      language.set(command);
      // 获取当前 URL 的哈希部分
      var currentHash = window.location.hash;
      // 解析查询参数字符串
      var paramsIndex = currentHash.indexOf('?');
      var hashWithoutParams = paramsIndex !== -1 ? currentHash.substring(0, paramsIndex) : currentHash;
      var queryParams = paramsIndex !== -1 ? currentHash.substring(paramsIndex + 1) : '';
      // 解析查询参数为对象
      var paramsObj = Object.fromEntries(new URLSearchParams(queryParams));
      // 如果 url 含有指定的语言，则删除指定的语言
      if (paramsObj.lang) {
        // 删除指定的查询参数
        delete paramsObj.lang;
        // 构建新的查询参数字符串
        var newQueryParams = new URLSearchParams(paramsObj).toString();
        // 构建新的 URL，并重新加载页面
        var newUrl = '' + hashWithoutParams + (newQueryParams ? '?' + newQueryParams : '');
        window.location.href = newUrl;
        window.location.reload();
      } else {
        this.refresh();
      }
    },
    visibleChange: function visibleChange(val) {
      this.visible = val;
    }
  },
  watch: {},
  computed: {
    languageCurrent: function languageCurrent() {
      var lang = localLanguage.get() || 'en';
      return this.languageList.find(function (item) {
        return item.value === lang;
      }).label;
    }
  }
};